import format from 'date-fns/format';
import isSameDay from 'date-fns/is_same_day';
import addDays from 'date-fns/add_days';
import getSeconds from 'date-fns/get_seconds';
import getMilliseconds from 'date-fns/get_milliseconds';
import getHours from 'date-fns/get_hours';
import getMinutes from 'date-fns/get_minutes';
import differenceInDays from 'date-fns/difference_in_days';
import startOfDay from 'date-fns/start_of_day';

export function formatTimeDuration(milliseconds,allowStep = true) {
  const diffInMins = milliseconds / 1000 / 60;

  if (diffInMins < 1) {
    return '1m';
  }

  const mins = Math.round(diffInMins);
  if (mins <= 59) {
    return (mins === 1) ? '1m' : `${mins}m`;
  }
  if(allowStep){
    const hours = Math.round(diffInMins / 60);
    if (hours <= 23) {
      return (hours === 1) ? '1h' : `${hours}h`;
    }

    const days = Math.round(diffInMins / 60 / 24);
    if (days >= 1) {
      return `${days}d`;
    }
  }else{
    const hours = (diffInMins / 60).toFixed(2);
    if (hours) {
      return (hours === 1) ? '1h' : `${hours}h`;
    }
  }
  

  return null;
}

export const isTrashDate = (date) => {
  if (getSeconds(date) || getMilliseconds(date)) {
    return false;
  }

  const hours = getHours(date);
  const minutes = getMinutes(date);

  return (hours === 23 && minutes === 59) || (hours === 0 && minutes === 0);
};

export function gradeAge(milliseconds) {
  const diffInHours = milliseconds / 1000 / 60 / 60;
  if (diffInHours > 24) {
    return 'old';
  }

  if (diffInHours > 1) {
    return 'ok';
  }

  return 'fresh';
}


const dateFormat = 'YYMMDD';

export const formatDate = (date, descriptToday) =>
  format(date, 'MMM D') + (descriptToday && isSameDay(new Date(), date) ? ', Today' : '');

const list = [0, 1, 2, 3];

export const allowedDates = () => list.map((i) => addDays(new Date(), i));
export const allowedDatesKeys = () => list.map((i) => format(addDays(new Date(), i), dateFormat));

export const dayKey = (date) => format(date, dateFormat);

export const dayString = (date) => format(date, 'YYYY-MM-DD');

export const isPastDay = (date, nowDate) => differenceInDays(startOfDay(date), nowDate) < 0;
export const datesWithoutPast = (dates, nowDate) => dates && dates.filter(date => !isPastDay(date, nowDate));



// WEBPACK FOOTER //
// ./src/misc/dates.js